import { render, staticRenderFns } from "./CreateCompensation.vue?vue&type=template&id=bb8b4cc2"
import script from "./CreateCompensation.vue?vue&type=script&lang=js"
export * from "./CreateCompensation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports